// Khối "Thông tin cá nhân" trên FormChuVuon — bắt buộc hết, trừ Ghi chú.
// Nơi cấp CCCD không nhập tay: suy ra từ ngày cấp theo mốc cơ quan cấp thẻ.

export const NOI_CAP_BO_CONG_AN = "Bộ Công an";
export const NOI_CAP_QLHC = "Cục Cảnh sát QLHC về TTXH";
export const NOI_CAP_DKQL = "Cục Cảnh sát ĐKQL cư trú và DLQG về dân cư";

export const DANH_SACH_NOI_CAP_CCCD = [NOI_CAP_BO_CONG_AN, NOI_CAP_QLHC, NOI_CAP_DKQL];

const MOC_BO_CONG_AN = "2024-07-01";
const MOC_QLHC = "2018-10-10";
const MOC_CCCD = "2016-01-01";

function ngayIso(giaTri) {
  const ngay = String(giaTri ?? "")
    .trim()
    .slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(ngay) ? ngay : "";
}

/** Nơi cấp theo ngày cấp CCCD. Trước 01/01/2016 hoặc ngày không hợp lệ → "". */
export function noiCapCccdTheoNgay(ngayCap) {
  const ngay = ngayIso(ngayCap);
  if (!ngay) return "";
  if (ngay >= MOC_BO_CONG_AN) return NOI_CAP_BO_CONG_AN;
  if (ngay >= MOC_QLHC) return NOI_CAP_QLHC;
  if (ngay >= MOC_CCCD) return NOI_CAP_DKQL;
  return "";
}

export function apDungNoiCapCccdTheoNgay(data) {
  return { ...data, noiCapCccd: noiCapCccdTheoNgay(data?.ngayCapCccd) };
}

export const TRUONG_CA_NHAN_CHU_VUON = [
  { key: "hoTen", nhan: "Họ và tên" },
  { key: "ngaySinh", nhan: "Ngày sinh" },
  { key: "cccd", nhan: "Số CCCD" },
  { key: "sdt", nhan: "Số điện thoại" },
  { key: "ngayCapCccd", nhan: "Ngày cấp CCCD" },
  { key: "email", nhan: "Email" },
  { key: "tinhMa", nhan: "Tỉnh/Thành phố" },
  { key: "xaMa", nhan: "Xã/Phường" },
  { key: "thon", nhan: "Thôn/Ấp" },
  { key: "diaChi", nhan: "Số nhà / Đường" },
  { key: "tenNganHang", nhan: "Ngân hàng" },
  { key: "soTkNganHang", nhan: "Số tài khoản" },
  { key: "chuTaiKhoan", nhan: "Tên chủ tài khoản" },
];

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function kiemTraThongTinCaNhanChuVuon(data) {
  const ketQua = apDungNoiCapCccdTheoNgay(data);
  const thieu = TRUONG_CA_NHAN_CHU_VUON.filter((t) => !String(ketQua?.[t.key] ?? "").trim()).map(
    (t) => t.nhan
  );
  if (thieu.length > 0) {
    throw new Error(`Vui lòng nhập đủ thông tin cá nhân: ${thieu.join(", ")}.`);
  }
  if (!ketQua.noiCapCccd) {
    throw new Error(
      "Ngày cấp CCCD phải từ 01/01/2016 trở đi. Nơi cấp được điền tự động theo ngày cấp."
    );
  }
  if (!EMAIL_RE.test(String(ketQua.email).trim())) {
    throw new Error("Email không hợp lệ.");
  }
  return ketQua;
}
